import { JsonNode } from '../../../../utils/types'
import { Editor, Path, Range } from 'slate'
import { isPathInRectangle } from './mergeCells'

export const getSelectedCellsInATable = (editor: Editor, tablePath: Path) => {
  const edgePaths = Range.edges(editor.selection as Range).map((point) => point.path)

  const [startRowPath, endRowPath] = edgePaths.map(
    // @ts-ignore
    (path) => Editor.above(editor, { at: path, match: (node) => node.type === 'tr' })?.[1]
  )

  return Editor.nodes(editor, {
    match: (node: JsonNode, path) =>
      (node.type === 'th' && isPathInRectangle(editor, path, tablePath, 'th')) ||
      (node.type === 'td' && isPathInRectangle(editor, path, tablePath)),
    at: [startRowPath, endRowPath]
  })
}
